
import {getWorkstationsByLocalId} from '../../../../../../crud/management_api/workstations';
import {getAllTerminalTypes} from '../../../../../../crud/configuration_api/terminal_types';


export interface WorkstationOption {
    id: number;
    name: string;
  }
  export interface Terminal_TypesOption{
    id: number;
    name: string;
    state: boolean;
  }

  
export const getWorkstationsOptions = async () => {
    // it should return a map of workstation names and ids
    // get the local id from the user context
      const userContext = localStorage.getItem('user');
      const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
      const response = await getWorkstationsByLocalId(localId);
      if (response) {
        const data = response.data;
        if (data) {
          const workstations:WorkstationOption[] = data.map((workstation:any) => {
            return {
              id: workstation.workstation_id,
              name: workstation.workstation_name,
            };
          });
          return workstations;
        }
      }
      return [];
    };
    
export const getTerminal_TypesOption = async () => {
      // it should return a map of workstation names and ids
      // get the local id from the user context
      const response = await getAllTerminalTypes();
      if (response) {
        const data = response.data;
        if (data) {
          const terminal:Terminal_TypesOption[] = data.map((terminals:any) => {
            return {
              id: terminals.terminal_type_id,
              name: terminals.terminal_type_name,
              state: terminals.state,
            };
          });
          return terminal;
        }
      }
      return [];
      };